import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from "react-router-dom";

import { Concepts, StaffOnlyWrapper, TabLink } from '../../../Shared';
import * as conceptsActions from '../../actions/concepts';
import * as proofreaderActivitiesActions from '../../actions/proofreaderActivities';
import Lesson from '../lessons/lesson';
import Lessons from '../lessons/lessons';

interface PathParamsType {
  [key: string]: string,
}

type AdminContainerProps = RouteComponentProps<PathParamsType> & {
  concepts: any;
  dispatch: Function;
}

class AdminContainer extends React.Component<AdminContainerProps> {
  componentDidMount() {
    const { dispatch, } = this.props
    dispatch(proofreaderActivitiesActions.startListeningToActivities());
    dispatch(conceptsActions.startListeningToConcepts());
  }

  render() {
    const { children, concepts, dispatch } = this.props
    const content = (
      <div style={{ display: 'flex', backgroundColor: "white", height: '100vw' }}>
        <section className="section is-fullheight" style={{ display: 'flex', flexDirection: 'row', paddingTop: 0, paddingBottom: 0, }}>
          <aside className="menu" style={{ minWidth: 220, borderRight: '1px solid #e3e3e3', padding: 15, paddingLeft: 0, }}>
            <p className="menu-label">
              General
            </p>
            <ul className="menu-list">
              <TabLink to='/admin/lessons'>Proofreader Activities</TabLink>
            </ul>
            <p className="menu-label">
              Supporting
            </p>
            <ul className="menu-list">
              <TabLink to='/admin/concepts'>Concepts</TabLink>
            </ul>
          </aside>
          <div className="admin-container">
            {children}
          </div>
        </section>
        <Switch>
          <Route component={Lesson} path="/admin/lessons/:lessonID" />
          <Route component={Lessons} path="/admin/lessons" />
          <Route
            path="/admin/concepts"
            render={() => (
              <Concepts
                concepts={concepts}
                containerClassName="container"
                excludeResponses={false}
                includeNewConceptForm={false}
                renderAsLinks={false}
              />
            )}
          />
        </Switch>
      </div>
    );

    return <StaffOnlyWrapper>{content}</StaffOnlyWrapper>;
  }
}

function select(state) {
  return {
    concepts: state.concepts
  };
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export default withRouter(connect(select, dispatch => ({dispatch}), mergeProps)(AdminContainer));
